import { COMPOSER_LOCATION, QUERY_SOURCE_TYPE } from 'components/agent_hub_components'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import { CONTACT_INTERACTION_LOCATIONS } from 'hooks/analytics_events/constants'

/**
 * Creates analytics event handlers for agent hub components
 * @param {Function} track - The track function from useTrack hook
 * @returns {Object} Object containing analytics event handlers
 */
export const createAnalyticsHandlers = (track) => ({
  trackTextboxClick: (location) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location,
        feature: 'ask_calendly',
        action: 'textbox_click'
      }
    })
  },

  trackThumbsFeedback: (isThumbsUp, responseId) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        action: isThumbsUp ? 'response_thumbs_up' : 'response_thumbs_down',
        response_id: responseId
      }
    })
  },

  trackNegativeFeedback: (feedbackSelection, feedbackDetails, responseId) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        action: 'submit_negative_feedback',
        feedback_selection: feedbackSelection,
        feedback_details: feedbackDetails,
        response_id: responseId
      }
    })
  },

  trackCopy: () => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        action: 'copy',
      }
    })
  },

  trackResponseView: (isTop, queryId, resultCategory, responseId) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        action: isTop ? 'response_view_top' : 'response_view_bottom',
        query_id: queryId,
        result_category: resultCategory,
        response_id: responseId
      }
    })
  },

  trackSearchSubmitted: (location, searchType) => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location,
        feature: 'ask_calendly',
        action: 'search_submitted',
        search_type: searchType
      }
    })
  },

  trackChatSearchSubmitted: () => {
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_INTERACTION,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        action: 'search_submitted',
        search_type: QUERY_SOURCE_TYPE.TEXT
      }
    })
  },

  trackAiResponded: (latency, querySourceType = QUERY_SOURCE_TYPE.TEXT) => {
    track({
      name: TRACKING_EVENT_NAMES.AI_RESPONDED,
      properties: {
        location: COMPOSER_LOCATION.CHAT_PAGE,
        feature: 'ask_calendly',
        type: querySourceType,
        response_count: 1,
        suggested_actions_count: 0,
        refusal_count: 0,
        latency
      }
    })
  },

  trackContactInteraction: (action, contactUuid) => {
    track({
      name: TRACKING_EVENT_NAMES.CONTACT_INTERACTION,
      properties: {
        action,
        location: CONTACT_INTERACTION_LOCATIONS.ASK_CALENDLY_CHAT,
        contact_uuid: contactUuid
      }
    })
  },

  trackNavigationLinkInChatClicked: (navigationLink) => {
    track({
      name: TRACKING_EVENT_NAMES.NAVIGATION_LINK_CLICKED,
      properties: {
        navigation_link: navigationLink,
        navigation_location: COMPOSER_LOCATION.CHAT_PAGE,
        source_url: '/app/ai'
      }
    })
  }
})
